import React from 'react'
import {Route, Switch} from 'react-router-dom'
import {NuvemshopCallbackPage} from '../pages/onboarding/NuvemshopCallbackPage'
import {NuvemshopCalendlyPage} from '../pages/onboarding/NuvemshopCalendlyPage'

export function PublicRoutes() {
  return (
    <Switch>
      <Route path='/nuvemshop/callback' component={NuvemshopCallbackPage} />
      <Route path='/nuvemshop/agendar' component={NuvemshopCalendlyPage} />
    </Switch>
  )
}
